<template>
  <div>
    <grid :config="{searchFields: ['title', 'venue', 'date']}" :data="eventData" class="u-1-of-1">
      <template v-slot:gridAdd>
        <!-- TODO update import procedure -->
        <router-link class="c-button c-button--secondary c-button--large c-button--icon"
                     exact :to="{ name: 'local.import'}">
          <svg role="img" class="c-button__icon">
            <use xlink:href="images/svg-symbols.svg#plus-icon"></use>
          </svg>
          <span class="c-button__label">{{$t("local.import")}}</span>
        </router-link>
      </template>
      <template v-slot:gridHeader>
        <div class="o-layout c-list__row u-padding-horizontal-small">
          <div class="o-layout__item u-3-of-6-at-medium">
            {{$t('title')}}
          </div>
          <div class="o-layout__item u-1-of-6-at-medium u-1-of-2-at-tiny">
            {{$t('venue')}}
          </div>
          <div class="o-layout__item u-2-of-6-at-medium u-1-of-2-at-tiny">
            {{$t('date')}}
          </div>
        </div>
      </template>
      <template v-slot:gridData="{element}">
        <div class="o-layout__item u-3-of-6-at-medium c-list__main-cell">
          <a class="c-list__link" @click.prevent="selected = element.id">
            {{element.title}}
          </a>
        </div>
        <div class="o-layout__item u-1-of-6-at-medium u-1-of-2-at-tiny">
          {{element.venue}}
        </div>
        <div class="o-layout__item u-2-of-6-at-medium u-1-of-2-at-tiny">
          {{element.date}}
        </div>
        <div v-if="selected === element.id" class="o-layout__item u-1-of-1 u-padding-vertical-small">
          {{ $t('local.login.role') }}
          <button v-for="role in $options.eventRoles" :key="role"
                  v-on:click.prevent="openLogin(element, role)"
                  class="c-button c-button--small c-button--primary u-margin-left-small">
            {{$t('role.' + role)}}
          </button>
        </div>
      </template>
    </grid>
    <div class="u-margin-top-medium u-padding-small">
      version: {{version}} <br/>
      <a href="https://www.scoreexpress.be/releases" target="_blank">{{ $t('versions') }}</a>
    </div>

    <modal :shown="loginRole" @closed="cancelLogin">
      <div class="c-panel__dropdown">
        <h4 class="c-panel__label u-margin-bottom-small">
          {{ loginEvent ? loginEvent.title : ''}}<br/>
          {{ $t('local.login.title', { role: $t('role.' + loginRole) }) }}
        </h4>
        <div v-if="feedback" class="c-form--error">{{feedback}}</div>
        <form @submit.prevent="login">
        <scePasswordField v-model="password" ref="password" name="password" label="password"/>
        <sceButton label="cancel" v-on:click="cancelLogin"
                   class="c-button--secondary"/>
        <sceButton v-on:click="login" label="login" class="c-button c-button--primary" />
        </form>
      </div>
    </modal>
  </div>
</template>
<script>
const moment = require('moment')
import map from 'lodash/map'
import sortBy from 'lodash/sortBy'

import auth from '@/auth'

export default {
  name:'localEvents',
  components: {
    grid: require('@/components/dataGrid.vue').default,
    modal: require('client/components/modal.vue').default,
  },
  eventRoles: ['organiser', 'judge', 'supervisor', 'observer'],
  data: function() {
    return {
      eventData: [],
      selected: false,
      loginRole: null,
      loginEvent: null,
      password: null,
      feedback: null,
    }
  },
  computed: {
    events: function() {
      return sortBy(this.$store.state.events.items, ['date_from', 'title']).reverse()
    },
    version: function() {
      return this.$store.state.environment.appVersion;
    },
  },
  created: function() {
    this.init()
  },
  watch: {
    events: function() {
      this.init()
    },
  },
  methods: {
    init: function() {
      this.eventData = map(this.events, item => {
        let event = {
          id: item.id,
          title: item.title,
          venue: item.venue,
          date: this.format(item.date_from) + ' - ' + this.format(item.date_to),
        }
        return event
      })
    },
    format: function(date){
      return moment(date).format('DD/MM/YYYY')
    },
    openLogin: function(event, role) {
      this.loginRole = role
      this.loginEvent = event
      this.$nextTick(() => {
        this.$refs.password.setFocus()
      })
    },
    cancelLogin: function() {
      this.loginRole = null
      this.loginEvent = null
      this.password = ''
    },
    login: function() {
      if (!this.loginRole || !this.loginEvent) return

      const credentials = {
        type: 'event',
        eventId: this.loginEvent.id,
        role: this.loginRole,
        password: this.password,
      }

      auth.login(credentials, 'homepage').then(() => {
        //this.cancelLogin()
      }, (resp) => {
        this.feedback = resp.body.error.message
      })
    }
  }
}
</script>
